import { render, staticRenderFns } from "./EditSupplier.vue?vue&type=template&id=63bf7377"
import script from "./EditSupplier.vue?vue&type=script&lang=js"
export * from "./EditSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports